/* eslint-disable no-undefined */
import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { createPricing } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { useAdminSubmit } from "../shared/use-admin-submit";
import PricingForm, { PricingFormType } from "./form";
import {
  CREATE_PRICING,
  GET_PRICING_TYPES,
  GET_THRESHOLD_TYPES,
} from "./queries";
import { buildPricingMutationInput } from "./pricing-form-utils";

const initialData: PricingFormType = {
  pricingTypeId: undefined,
  thresholdTypeId: undefined,
  minimumPrice: undefined,
  unitThreshold: undefined,
  annualDiscountPercent: undefined,
  monthlyPricePerUnit: undefined,
  tiers: [],
};

const NewPricing: React.FC = () => {
  const { sending, submit } = useAdminSubmit("/dash/admin/pricing");
  const [createPricingFunc] = useMutation<createPricing>(CREATE_PRICING, {
    refetchQueries: ["pricingAll", "pricingAllForPlans", "pricingAllForSubscriptions"],
  });
  const { data: pricingTypesData } = useQuery(GET_PRICING_TYPES);
  const { data: thresholdTypesData } = useQuery(GET_THRESHOLD_TYPES);

  const submitForm = (formData: PricingFormType) =>
    submit(() =>
      createPricingFunc({
        variables: { data: buildPricingMutationInput(formData) },
        refetchQueries: ["pricingAll", "pricingAllForPlans", "pricingAllForSubscriptions"],
        awaitRefetchQueries: true,
      }));

  const pricingTypes = pricingTypesData?.pricingTypes || [];
  const thresholdTypes = thresholdTypesData?.thresholdTypes || [];

  return (
    <div>
      <AdminHeading>Create Pricing Configuration</AdminHeading>
      <PricingForm
        formType="new"
        initialData={initialData}
        sending={sending}
        handleSubmit={submitForm}
        pricingTypes={pricingTypes}
        thresholdTypes={thresholdTypes}
      />
    </div>
  );
};

export default NewPricing;
